import React from 'react';
import { Row } from 'antd';
import ChatRenderText from '../Text';
import Option from '../../Option';

interface ChatPredictOptionsProps {
  message: React.ComponentProps<typeof ChatRenderText>['message'] & {
    metadata?: {
      subscriptionOptions: {
        name: string;
        option: string;
      }[];
    };
  };
  onSelect: React.ComponentProps<typeof Option>['onClick'];
  showOptions?: boolean;
}

const ChatPredictOptions = function ({
  message,
  onSelect,
  showOptions = false,
}: ChatPredictOptionsProps) {
  const {
    metadata: {
      subscriptionOptions = [],
    } = {},
  } = message;

  return (
    <Row style={{ width: '100%' }}>
      <div className="chat-message-wrapper">
        <ChatRenderText message={message} tooltip={false}>
          {showOptions && (
            subscriptionOptions.map(({ name, option }) => (
              <Option key={option} id={option} name={name} onClick={onSelect} />
            ))
          )}
        </ChatRenderText>
      </div>
    </Row>
  );
};

export default ChatPredictOptions;
